import { TOKEN_LOCAL_STORAGE_KEY } from 'codegen/fetcher/fetcher.utils'
import { localStore, sessionStore } from 'utils/storage'

export function getUserIdFromToken(): string | undefined {
  try {
    const token = localStore.getString(TOKEN_LOCAL_STORAGE_KEY)
    if (!token) {
      return undefined
    }
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.sub ?? undefined
  } catch {
    return undefined
  }
}
